import React, { useMemo } from "react"
import type { CSSProperties } from "react"
import { StyleSheet } from "~/ui/primitives"
import { useTheme } from '~/ui/styled'
import { observer } from "mobx-react-lite"
import { useStores } from "~models"
import { StartFlex, ColumnFlex, CenterFlex, BetweenFlex, Button, Text, IconFont } from "~components/El"
import useNavigation from "~hooks/useNavigation"
const FriendAccordion = () => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { friendStore } = useStores()
  const count = friendStore.friendsCount
  const columns = useMemo(() => {
    const rowBorder: CSSProperties = {
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.colors.border,
      borderBottomStyle: "solid",
    }
    return [
      {
        title: "新的朋友",
        icon: "tjhy",
        iconBg: theme.colors.primary,
        count: count,
        style: rowBorder,
        onClick: () => {
          navigation.navigate("FriendList")
        },
      },
      {
        title: "群聊",
        icon: "qlltz",
        iconBg: theme.colors.warning,
        count: 0,
        style: rowBorder,
        onClick: () => {
          navigation.navigate("GroupList")
        },
      },
      {
        title: "频道",
        icon: "pd",
        iconBg: theme.colors.purpleBackground,
        count: 0,
        style: undefined as CSSProperties | undefined,
        onClick: () => {
          navigation.navigate("ChannelList")
        },
      },
    ]
  }, [count, navigation, theme.colors.border, theme.colors.primary, theme.colors.purpleBackground, theme.colors.warning])
  return (
    <StartFlex width="100%" height="auto" alignItems="stretch" padding="10px 12px">
      <ColumnFlex
        width="100%"
        height="auto"
        alignItems="stretch"
        padding="0 12px"
        borderRadius={theme.space.sm}
        bg={theme.colors.blockBackground}
      >
        {columns.map((item, index) => (
          <StartFlex
            key={index}
            width="100%"
            height="auto"
            flexDirection="row"
            alignItems="center"
            onClick={item.onClick}
            style={{ cursor: "pointer" }}
          >
            <>
              <CenterFlex
                width="36px"
                height="36px"
                borderRadius="18px"
                bg={item.iconBg}
              >
                <IconFont name={item.icon} color={theme.colors.textLight} size={20} />
              </CenterFlex>
              <BetweenFlex
                flex={1}
                width="100%"
                minWidth={0}
                padding="22px 0"
                ml="10px"
                style={item.style}
              >
                <Text color={theme.colors.text} fontSize={theme.fontSizes.md}>{item.title}</Text>
                <StartFlex width="auto" height="auto">
                  {item.count > 0 && (
                    <CenterFlex
                      width="18px"
                      height="18px"
                      mr="10px"
                      borderRadius="9px"
                      bg={theme.colors.error}
                    >
                      <Text color={theme.colors.textLight} fontSize={theme.fontSizes.sm}>{item.count}</Text>
                    </CenterFlex>
                  )}
                  
                  <IconFont name="right" color={theme.colors.secondary} size={14} />
                </StartFlex>
              </BetweenFlex>
            </>
          </StartFlex>
        ))}
        
      </ColumnFlex>
      
    </StartFlex>
    
  )
}

export default observer(FriendAccordion)
